import { SET_GUEST_TENANT_ID, ISetGuestTenantId } from "./guest-tenant-types";

export const setGuestTenantId = (guestTenantId: string): ISetGuestTenantId => ({
    type: SET_GUEST_TENANT_ID,
    guestTenantId,
});
